import { render } from "./Introduction.md?vue&type=template&id=4040fe74"
const script = {}
script.render = render

export default script